export const emailBlockList: string[] = [
  '@0bigpond.n',
  '@aim.com',
  '@alice.it',
  '@aliceadsl.fr',
  '@aol.co',
  '@arcor.de',
  '@att.net',
  '@bellsouth.net',
  '@bigpond.com',
  '@bluewin.ch',
  '@blueyonder.co.uk',
  '@bol.com.br',
  '@centurytel.net',
  '@charter.net',
  '@chello.nl',
  '@club-internet.fr',
  '@comcast.net',
  '@cox.net',
  '@earthlink.net',
  '@facebook.com',
  '@free.fr',
  '@freenet.de',
  '@frontiernet.net',
  '@gmail.com',
  '@gmx.de',
  '@gmx.net',
  '@googlemail.co',
  '@hetnet.nl',
  '@home.nl',
  '@hotmail.co.uk',
  '@hotmail.com',
  '@hotmail.de',
  '@hotmail.es',
  '@hotmail.fr',
  '@hotmail.it',
  '@ig.com.br',
  '@juno.com',
  '@laposte.net',
  '@libero.it',
  '@live.ca',
  '@live.co.uk',
  '@live.com',
  '@live.com.au',
  '@live.fr',
  '@live.it',
  '@live.nl',
  '@mac.com',
  '@mail.com',
  '@mail.ru',
  '@me.com',
  '@msn.com',
  '@neuf.fr',
  '@ntlworld.com',
  '@optonline.net',
  '@optusnet.com.au',
  '@orange.fr',
  '@outlook.com',
  '@planet.nl',
  '@qq.com',
  '@rambler.ru',
  '@rediffmail.com',
  '@rocketmail.com',
  '@sbcglobal.net',
  '@sfr.fr',
  '@shaw.c',
  '@sky.co',
  '@skynet.be',
  '@sympatico.ca',
  '@t-online.de',
  '@telenet.be',
  '@terra.com.br',
  '@tin.it',
  '@tiscali.co.uk',
  '@tiscali.i',
  '@uol.com.br',
  '@verizon.net',
  '@virgilio.it',
  '@voila.fr',
  '@wanadoo.f',
  '@web.de',
  '@windstream.net',
  '@yahoo.ca',
  '@yahoo.co.i',
  '@yahoo.co.id',
  '@yahoo.co.j',
  '@yahoo.co.uk',
  '@yahoo.com',
  '@yahoo.com.ar',
  '@yahoo.com.au',
  '@yahoo.com.br',
  '@yahoo.com.mx',
  '@yahoo.com.sg',
  '@yahoo.de',
  '@yahoo.e',
  '@yahoo.fr',
  '@yahoo.in',
  '@yahoo.it',
  '@yandex.ru',
  '@ymail.com',
  '@zonnet.nl',
];
